<template>
    <b-card
        no-body
    >
        <div class="card-header">
            <div
                class="card-group-title"
            >
                <b-form-select
                    v-model="tagKey"
                    class="width-200"
                >
                    <b-form-select-option
                        v-for="(tag, index) in data.availableTags"
                        :key="index"
                        :value="tag.substring(4)"
                    >
                        {{ tag }}
                    </b-form-select-option>
                </b-form-select>
            </div>
            <a
                data-action="collapse"
                :class="{ rotate: isCollapsed }"
                @click="triggerCollapse"
                class="mr-2"
            >
                <feather-icon
                    icon="ChevronDownIcon"
                    size="16"
                />
            </a>
        </div>
        <b-alert
            :show="showDismissibleFilter"
            variant="info"
            dismissible
            @dismissed="dismissed"
        >
            <div class="alert-body">
                <feather-icon
                    icon="SearchIcon"
                />
                {{ tagValue }}
            </div>
        </b-alert>
        <b-collapse
            v-model="visible"
            :visible="visible"
            class="card-content"
        >
            <b-table-simple
                v-if="data.tag.length !== 0"
                sticky-header
            >
                <b-tbody class="dynamic-search">
                    <b-tr v-for="(item, index) in data.tag" :key="index">
                        <b-td>
                            <!-- <vs-badge v-if="index < 3"> {{ index + 1 }} </vs-badge> -->
                            <a href="javascript:;" @click="handleLabelClick(item.value)">
                                {{ item.value }}
                            </a>
                        </b-td>
                        <b-td class="text-right" style="width:30%;">
                            {{ $_getDollar(item.cost) }}
                        </b-td>
                    </b-tr>
                </b-tbody>
            </b-table-simple>
        </b-collapse>
        <hr class="mt-0">
        <h4 class="pb-50 text-center">
            {{ data.tag.length }}
            <small>
                / {{ $_getNumberFormat(count, 0) }} {{ $t('v4.total tag values') }}
            </small>
        </h4>
    </b-card>
</template>

<script>
import useSelectProjectAndGroup from '@/composables/useSelectProjectAndGroup'
import { toRefs, ref, watch } from '@vue/composition-api'
export default {
    props: {
        field: {
            type: String
        },
        count: {
            type: Number,
            default: 0
        },
        data: {
            type: Object,
            default: function () {
                return {
                    tag: [],
                    availableTags: []
                }
            }
        }
    },
    setup (props, context) {
        const { changeProject } = useSelectProjectAndGroup()
        const { field } = toRefs(props)
        const visible = ref(false)
        const isCollapsed = ref(false)
        const showDismissibleFilter = ref(false)
        const tagKey = ref('Name')
        const tagValue = ref('')
        const triggerCollapse = () => {
            visible.value = !visible.value
        }
        const handleLabelClick = (value) => {
            showDismissibleFilter.value = true
            tagValue.value = value
            context.emit('filter:items', { field: field.value, value: { key: tagKey.value, value } })
        }
        const handlerResetValue = () => {
            showDismissibleFilter.value = false
            tagValue.value = undefined
            context.emit('filter:items', { field: field.value, value: { key: tagKey.value, value: undefined } })
        }
        watch(tagKey, (value, oldValue) => {
            handlerResetValue()
        })
        const dismissed = () => {
            if (!tagValue.value) return
            handlerResetValue()
        }
        watch(changeProject, (_) => {
            tagValue.value = undefined
            showDismissibleFilter.value = false
        })
        return {
            dismissed,
            tagKey,
            tagValue,
            isCollapsed,
            visible,
            triggerCollapse,
            showDismissibleFilter,
            handleLabelClick,
            handlerResetValue
        }
    }
}
</script>

<style lang="scss">
table.table {
    tbody.dynamic-search {
        tr:first-child {
            td {
                border-top: 0px;
            }
        }
    }
}
</style>
